/** A user's kind as a chip: neutral outline, an icon and the word.
 *
 *  Kind is a category, not a state, so it carries no colour — red is for danger and
 *  the tenant dashboard's blue is never ours (DESIGN.md, Signal-Red and Navy rules).
 *  The icon tells the three apart at a glance; the word carries the meaning. */
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Chip, type ChipProps } from '@mui/material';
import type { ReactElement } from 'react';

import type { UserKind } from '@/api/users';

const KIND: Record<UserKind, { label: string; icon: ReactElement }> = {
  system: { label: 'System', icon: <AdminPanelSettingsOutlinedIcon /> },
  staff: { label: 'Staff', icon: <BadgeOutlinedIcon /> },
  guest: { label: 'Guest', icon: <PersonOutlineIcon /> },
};

export function UserKindChip({ kind, sx }: { kind: UserKind; sx?: ChipProps['sx'] }) {
  const { label, icon } = KIND[kind];
  return <Chip size="small" variant="outlined" icon={icon} label={label} sx={sx} />;
}
